import axios from "axios";

function createPricingRules(newRules) {
  return axios.post("/api/pricing/rules/global", newRules);
}

function updatePricingRules(updatedRules) {
  return axios.put("/api/pricing/rules", updatedRules);
}

async function getPricingRules(
  params = {
    pageLimit: 25,
    pageNumber: 1,
    pageType: "GLOBAL",
    priority: "GLOBAL",
  }
) {
  try {
    const { data } = await axios.get("/api/pricing/rules", { params });
    return data;
  } catch (error) {
    console.log("Error getting pricing rules");
    //Whatever you'd like to have we can return here
  }
}

export { createPricingRules, updatePricingRules, getPricingRules };